export default "__VITE_ASSET__CGvs5Hrw__"